import React from 'react'
// import { Label } from 'semantic-ui-react'
import { Button, Input, Select } from 'antd'
import R from 'ramda'
import styled from 'styled-components'
import { fromNullable } from 'data.maybe'
import { connect } from 'react-redux'
import { retrieveGoals, setYear } from '../actions'

import { getLoading, getMetricDisplayMap, getGoalKpis, getYear } from '../selectors'

const currentYear = new Date().getFullYear()

const years = R.range(2000, currentYear + 20).map(i => ({
  key: i,
  value: i,
  text: `${i}`,
}))

const MetricContainer = styled.div`
  margin-top: 10px;
`
const Container = styled.div`
  padding: 10px;
`

const Label = styled.div`
  margin-left: 1em;
  position: relative;
  padding-left: 1.5em;
  padding-right: 1.5em;
  border-radius: 0 0.28571429rem 0.28571429rem 0;
  transition: none;
  cursor: pointer;
  font-size: 0.85714286rem;
  display: inline-block;
  line-height: 1;
  vertical-align: baseline;
  margin: 0 0.14285714em;
  background-color: ${props => (props.color ? props.color : '#e8e8e8')};
  background-image: none;
  padding: 0.5833em 0.833em;
  color: rgba(0, 0, 0, 0.6);
  text-transform: none;
  font-weight: 700;
  border: 0 solid transparent;
`

export const GoalCriteria = ({
  yearChanged,
  year,
  retrieve,
  metrics,
  selected,
  metricSelected,
  unitFilter,
  unitFilterChanged,
  loading,
  displayMap,
  ...rest
}) => (
  <Container {...rest}>
    <Select selection onChange={yearChanged} value={year} size="small">
      {years.map(y => (
        <Select.Option key={y.key} value={y.value}>
          {y.text}
        </Select.Option>
      ))}
    </Select>
    <Button
      style={{ marginLeft: '5px' }}
      onClick={retrieve}
      type="primary"
      size="small"
      loading={loading}
    >
      Retrieve Goal
    </Button>
    <Input
      icon="filter"
      placeholder="Filter Units..."
      size="small"
      value={fromNullable(unitFilter).getOrElse('')}
      onChange={unitFilterChanged}
    />
    <MetricContainer>
      {metrics.map(m => (
        <Label
          style={{ marginBottom: '5px' }}
          as="a"
          key={m}
          size="large"
          color={selected.includes(m) ? 'grey' : undefined}
          onClick={_ => metricSelected(m)}
        >
          {fromNullable(displayMap)
            .chain(map => fromNullable(map[m]))
            .getOrElse(m)}
        </Label>
      ))}
    </MetricContainer>
  </Container>
)
//
const mapStateToProps = state => ({
  metrics: getGoalKpis(state),
  loading: getLoading(state),
  displayMap: getMetricDisplayMap(state),
  year: getYear(state),
})

const mapDispatchToProps = dispatch => ({
  retrieve: () => dispatch(retrieveGoals()),
  yearChanged: value => dispatch(setYear(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(GoalCriteria)
